"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BestLabel = _interopRequireDefault(require("./BestLabel"));
var _BestSelect = _interopRequireDefault(require("./BestSelect"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var BestDropdown = function BestDropdown(_ref) {
  var title = _ref.title,
    value = _ref.value,
    options = _ref.options,
    onChange = _ref.onChange,
    id = _ref.id,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    rest = _objectWithoutProperties(_ref, ["title", "value", "options", "onChange", "id", "required", "styles"]);
  var dropDownId = "best-dropdown-" + id;
  return _react["default"].createElement("div", {
    id: dropDownId
  }, _react["default"].createElement(_BestLabel["default"], {
    required: required,
    htmlFor: id
  }, title), _react["default"].createElement(_BestSelect["default"], _extends({
    options: options,
    value: value,
    onChange: onChange,
    id: id,
    styles: styles
  }, rest)));
};
BestDropdown.propTypes = {
  /** name of the select */
  name: _propTypes["default"].string,
  /** title for the select */
  title: _propTypes["default"].string.isRequired,
  /** options to display in the select */
  options: _propTypes["default"].array.isRequired,
  /** value of the select */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]).isRequired,
  /** on change callback from the dropdown */
  onChange: _propTypes["default"].func.isRequired,
  /** if the dropdown is required */
  required: _propTypes["default"].bool,
  /** ID to display */
  id: _propTypes["default"].string,
  /** placeholder for the select */
  placeholder: _propTypes["default"].string,
  /** menu portal target */
  portal: _propTypes["default"].object,
  /** if the input is disbaled */
  isDisabled: _propTypes["default"].bool,
  /** If the select is a multi select */
  isMulti: _propTypes["default"].bool,
  /** backspace removed */
  backspaceRemoves: _propTypes["default"].bool,
  /** Delete removes the values */
  deleteRemoves: _propTypes["default"].bool,
  /** is the select clearable */
  clearable: _propTypes["default"].bool,
  /** overrideable styles object from the react-select library */
  styles: _propTypes["default"].object
};
BestDropdown.defaultProps = {
  clearable: false,
  backspaceRemoves: false,
  deleteRemoves: false,
  className: "",
  placeholder: "",
  name: "best-select",
  portal: null,
  isDisabled: false,
  isMulti: false,
  styles: {},
  required: false,
  id: "best-dropdown"
};
var _default = BestDropdown;
exports["default"] = _default;